export const TIMESHEET_PATH = "/timesheet";
